import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const AUDIO_CONTROL_EVENT_NAMES = {
  MUTE_AUDIO_CONTROL: 'mute_sound_control_clicked_csp',
  CHANGE_AUDIO_VOLUME: 'audio_notifications_volume_changed_csp',
};

export const trackClickMuteAudioControl = (irpVersion, type) => {
  gspx.trackEvent({
    name: AUDIO_CONTROL_EVENT_NAMES.MUTE_AUDIO_CONTROL,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Mute Sound Control for ${type} was clicked in CSP`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackChangeAudioVolume = (irpVersion, type) => {
  gspx.trackEvent({
    name: AUDIO_CONTROL_EVENT_NAMES.CHANGE_AUDIO_VOLUME,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `The volume for ${type} Audio Notifications was changed in CSP`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
